import { getDedicatedCalendarAccounts } from '@frontend/api-client';
import { useMemo } from '@frontend/react';
import { Text, YStack } from '@frontend/web-react';
import { Calendar } from '@frontend/web/components';
import { useListOAuthAccountsQuery, useRetrieveClientQuery } from '@frontend/web/hooks';

export const PersonalizeContainer = () => {
  const { data: client } = useRetrieveClientQuery();
  const { data: oAuthAccounts, isLoading, refetch: refetchOAuthAccounts } = useListOAuthAccountsQuery();
  const dedicatedCalendarAccounts = getDedicatedCalendarAccounts(oAuthAccounts);

  const integratedCalendar = useMemo(
    () => dedicatedCalendarAccounts?.find((o) => o.client === client?.id),
    [dedicatedCalendarAccounts, client],
  );

  const completedAllIntegrations = Boolean(integratedCalendar);

  if (completedAllIntegrations) return null;
  return (
    <YStack gap="md">
      {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
      <Text color="primary" type="p-sm">
        Personalize your experience
      </Text>
      {!isLoading && !integratedCalendar ? (
        <YStack gap="md">
          <Calendar integratedCalendar={integratedCalendar} refetchOAuthAccounts={refetchOAuthAccounts} />
        </YStack>
      ) : null}
    </YStack>
  );
};
